import {
    tss,
} from 'app/tss'

export default tss
    .withParams<{ disabled: boolean }>()
    .create(({
        theme,
        disabled,
    }) => {
        return {
            dataGridContainer: {
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                background: theme.palette.common.white,
                borderRadius: 4,
                '& .MuiDataGrid-root': {
                    borderTopRightRadius: 4,
                    borderBottomRightRadius: 4,
                    background: theme.palette.common.white,
                },
                '& .Mui-selected': {
                    backgroundColor: `${theme.palette.primary[30]}`,
                },
                '& .MuiDataGrid-row': {
                    minHeight: '36px !important',
                },
                '& .MuiDataGrid-row:hover': {
                    backgroundColor: `${theme.palette.primary[50]} !important`,
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    fontSize: '14px !important',
                    fontWeight: '500 !important',
                    color: `${theme.palette.secondary[700]} !important`,
                },
                '& .MuiDataGrid-main': {
                    background: theme.palette.common.white,
                    margin: `${theme.spacing(2)} ${theme.spacing(1)}`,
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.20)',
                    borderRadius: theme.spacing(0.5),
                },
                '& .MuiDataGrid-cell:focus': {
                    outline: 'none !important',
                },
                '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
                    opacity: disabled ? 0.45 : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                },
                '& .MuiDataGrid-columnHeaderCheckbox .Mui-checked': {
                    opacity: disabled ? 0.26 : 1,
                    color: disabled ? `${theme.palette.common.black}` : `${theme.palette.primary.main}`,
                },
                '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-indeterminate': {
                    opacity: disabled ? 0.26 : 1,
                    color: disabled ? `${theme.palette.common.black}` : `${theme.palette.primary.main}`,
                },
            },
            archiveIconWrapper: {
                margin: '0 !important',
                padding: '0 !important',
            },
            archiveLink: {
                padding: '0 !important',
            },
            filterPanel: {
                width: '560px',
                minHeight: '120px',
                maxHeight: '560px',
                '&& .MuiDataGrid-panelContent': {
                    overflowY: 'auto',
                    maxHeight: 'unset',
                },
                '&& .MuiInputLabel-root': {
                    left: '-14px !important',
                    color: theme.palette.secondary[700],
                },
                '&& .MuiDataGrid-filterForm': {
                    alignItems: 'flex-end',
                },
            },
            filterPanelColumnInput: {
                marginTop: '6px !important',
                '&& .Mui-disabled': {
                    '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
                },
                '&.Mui-disabled:before': {
                    border: 'none !important',
                },
                '&& .MuiSelect-icon.Mui-disabled': {
                    display: 'none !important',
                },
            },
            filterPanelHiddenElement: {
                display: 'none !important',
            },
            filterPanelDeleteIcon: {
                '&& .Mui-disabled': {
                    visibility: 'hidden',
                },
            },
        }
    })
